<template>
  <div class="user_page">
    <div class="admin_main">
      <div class="admin_container">
        <div class="scan-qr_btn mb-3 d-flex justify-space-between align-center">
          <div class="pa-2">
            <BackBtn />
          </div>
          <div class="py-2">
            <VueSelect
              v-if="showWarehouses"
              clearable
              rules="required"
              :items="warehouses"
              v-model="warehouseId"
              item-text="name"
              :placeholder="$t('warehouse')"
              class="pr-3"
            ></VueSelect>
          </div>
          <VBtn
            color="success"
            :disabled="isConfirmDisabled"
            @click="confirmProducts"
            >{{ $t("admissionConfirmation") }}
          </VBtn>
        </div>

        <div class="division_main">
          <div class="mobile_simple overflow-auto">
            <TableWithFilter
              :headers="headers"
              :items="items"
              fixed-header
              :is-filterable="false"
            >
            </TableWithFilter>
          </div>
        </div>
      </div>
    </div>
    <EImzoDialog ref="eimzoDialogRef" @getToken="setHashESign"></EImzoDialog>
  </div>
</template>

<script>
import EImzoDialog from "@/components/omtk/E-imzoDialog.vue";
import TableWithFilter from "@/components/ui/table/TableWithFilter.vue";
import BackBtn from "@/components/ui/BackBtn";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import { makerPagination } from "@/utils/pureFunctions.js";
import { USER_CONFIG } from "@/utils/constants";

export default {
  data() {
    return {
      items: [],
      warehouses: [],
      warehouseId: null,
      showWarehouses: false,
    };
  },
  props: {
    id: {
      required: true,
    },
  },
  components: {
    EImzoDialog,
    TableWithFilter,
    BackBtn,
    VueSelect,
  },
  async created() {
    await this.getWarehouse();
  },
  methods: {
    async getItems() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get(
          `given-products/list-product-item?orderItemId=${this.id}`
        );
        this.items = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    confirmProducts() {
      if (this.userConfig[USER_CONFIG.DIGITAL_SIGNATURE] === "NONE") {
        this.acceptProducts();
      } else {
        this.openEimzoDialog();
      }
    },
    openEimzoDialog() {
      const { eimzoDialogRef } = this.$refs;
      if (eimzoDialogRef) {
        eimzoDialogRef.open([+this.id]);
      }
    },
    async setHashESign(hashESign) {
      this.showLoading();
      try {
        let params = {
          hashESign: hashESign,
          id: this.id,
        };
        await this.$http.post("orders/set-hash-e-sign", params);
        await this.acceptProducts();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    setWarehouses(warehouses) {
      this.warehouses = warehouses;
    },
    async getWarehouse(params) {
      this.showLoading();
      try {
        const {
          data: { data, total },
        } = await this.$http.get("warehouse/own-list", {
          params,
        });
        if (data.length === 1) {
          this.showWarehouses = false;
          this.warehouseId = data[0].id;
        } else if (data.length > 1) {
          this.showWarehouses = true;
        }
        this.setWarehouses(data);

        return {
          data,
          lastPage: makerPagination({ limit: 50, total }).lastPage,
        };
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async acceptProducts() {
      this.showLoading();
      try {
        const orderItemIds = this.items
          .map((item) => `productItemIds=${item.id}`)
          .join("&");

        await this.$http.post(
          `given-products/accepting-products?orderItemId=${this.id}&${orderItemIds}&warehouseId=${this.warehouseId}`
        );
        this.setSuccess({
          text: this.$t("serverErrorMessages.PRODUCT_RECEIVED"),
        });
        await this.$router.push({ name: "division-accept" });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  computed: {
    userConfig() {
      return this.$store.getters.user.config;
    },
    headers() {
      return [
        {
          value: "count",
          text: this.$t("count"),
        },
        {
          value: "id",
          text: this.$t("qrCode"),
        },
        {
          value: "name",
          text: this.$t("productName"),
        },
      ];
    },
    isConfirmDisabled() {
      return this.items.length === 0 || this.warehouseId === null;
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
